import React, { useCallback, useEffect, useRef } from "react";

const SearchBoxComponent = ({ onPlaceSelected }) => {
  // Reference to the input element
  const inputRef = useRef(null);
  // Reference to the autocomplete instance
  const autocompleteRef = useRef(null);

  // Callback to handle place selection
  const handlePlaceChanged = useCallback(() => {
    const place = autocompleteRef.current.getPlace();
    if (place.geometry) {
      const location = {
        lat: place.geometry.location.lat(),
        lng: place.geometry.location.lng(),
      };
      onPlaceSelected(location);
    }
  }, [onPlaceSelected]);

  // Initialize the autocomplete instance when the component mounts
  useEffect(() => {
    if (inputRef.current) {
      autocompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
      );
      autocompleteRef.current.addListener("place_changed", handlePlaceChanged);
    }
  }, [handlePlaceChanged]);

  return (
    <input
      className="input"
      ref={inputRef}
      type="text"
      placeholder="بحث عن موقع"
    />
  );
};

export default SearchBoxComponent;
